<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="router"></Header>
    <!-- banner -->
    <div class="banner-bg">
      <div class="banner-box">
        <div class = "banner-text">
          <div class="banner-title">是客户，也是伙伴</div>
          <div class="banner-desc">深耕信息化20余年，轻骑兵助力千行百业成功交付<span class="highlighted-number">10000+</span>应用</div>
        </div>
        <div class="customerComments">
          <div class="developmentExperience customerCommentsStyle showOrHide1" >
            <div>
              <img src="../assets/img/casePage/people.png">
              可视化开发体验非常好，领先全行业
            </div>
          </div>
          <div class="poc customerCommentsStyle showOrHide2" >
            <div>
              <img src="../assets/img/casePage/people.png">
              poc验证优势明显
            </div>
          </div>
          <div class="technicalRoutes customerCommentsStyle showOrHide3" >
            <div>
              <img src="../assets/img/casePage/people.png">
              统一了技术路线
            </div>
          </div>
          <div class="safe customerCommentsStyle showOrHide4" >
            <div>
              <img src="../assets/img/casePage/people.png">
              资质很全，安全性有保障
            </div>
          </div>
          <div class="expansion customerCommentsStyle showOrHide5">
            <div>
              <img src="../assets/img/casePage/people.png">
              最看重二次开发拓展能力
            </div>
          </div>
          <div class="service customerCommentsStyle showOrHide6">
            <div>
              <img src="../assets/img/casePage/people.png">
              一对多服务，效率非常高
            </div>
          </div>
          <div class="reversible customerCommentsStyle showOrHide7">
            <div>
              <img src="../assets/img/casePage/people.png">
              被高还原性打动
            </div>
          </div>
          <div class="costSave customerCommentsStyle showOrHide8">
            <div>
              <img src="../assets/img/casePage/people.png">
              节省了上百万成本
            </div>
          </div>
          <div class="nationalInternet customerCommentsStyle showOrHide9">
            <div>
              <img src="../assets/img/casePage/people.png">
              完全满足国产信创的需求
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  客户案例  -->
    <div class="customCase clearfix">
      <div class="customTitle">典型案例</div>
      <div class="article-box" >
          <div class="customArticle" v-for = "(item) in article ">
            <router-link :to="{
            path: '/CasePage/CasePageArticle',
            query: {
              id: item.id,
            },
          }">
              <div class = "customImg"><img v-lazy="'http://www.jxdinfo.com'+item.typeImg" style="width: 100%"></div>
              <div class="customArticleTitle">{{ item.title }} <span v-if="item.shortTitle" :style="{color: getColor(item.shortTitle).color,background: getColor(item.shortTitle).background}">{{item.shortTitle}}</span></div>
              <div class="customArticleDesc">{{ item.description }}</div>
            </router-link>
          </div>
      </div>
      <div class="overIndex" v-if="articleTotal > 8 "><img src="../assets/img/casePage/turn-page-left.png" @click="forward()">
        <span>{{this.articleData.pageNo}}/{{this.articlePage}}</span>
        <img src="../assets/img/casePage/turn-page-right.png" @click="backward()">
      </div>
    </div>
    <!--  应用行业  -->
    <div class="application clearfix">
      <div class="customTitle">应用行业</div>
      <div class="applicationBox">
        <div class="applicationCustom"  v-for = "(item) in application " >
          <div class="applicationSeat">
            <img v-lazy="'http://www.jxdinfo.com'+item.typeImg" >
            <div class="applicationCustom-desc">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--  更多客户  -->
    <div class="custom-box clearfix">
      <div class="customTitle">客户心声</div>
      <CustomCommentSwiper></CustomCommentSwiper>
      <div class="customTitle" id="moreCustom">更多客户</div>
        <div class="customLogo-box clearfix" >
          <CustomerLogoSlider />
          <!-- <img src="../assets/img/casePage/customers.png"> -->
          <!-- <div class="customLogo" v-for = "(item) in customLogo ">
            <img :src="'http://www.jxdinfo.com'+item.typeImg" >
          </div> -->
        </div>
    </div>

    <!--联系专家-->

    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
<!--    <Footer></Footer>-->
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
import Header from './include/Header.vue';
import Footer from './include/Footer.vue';
import HussarForm from "./include/HussarForm";
import ContactExperts from './include/ContactExperts.vue';
import CustomCommentSwiper from './CustomCommentSwiper.vue';
import CustomerLogoSlider from './CustomerLogoSlider.vue';




import {getCustomCase, getApplication, getCustomLogo} from "../api/casePage.js";
import SideBar from "./include/SideBar";
export default {
  name: "CasePage",
  data() {
    return {
      router:'/CasePage',
      headColor:"light",
      isPageScroll: false,
      showForm: false,
      article:[],
      application:[],
      id:0,
      articleData: {
        channelId:287,
        pageNo: 1,
        pageSize: 8,
      },
      articleTotal:0,
      articlePage:0,
      applicationData: {
        channelId:288
      },
      customLogoData:{
        channelId:290
      },
      customLogo:[],
      colorList:[
        {
          name:'新能源',
          color:'#00A2DF',
          background:'#D2F3FF',
        },
        {
          name:'航天航空',
          color:'#2682FF',
          background: '#D2E5FF',
        },
        {
          name:'电力',
          color:'#EC9C23',
          background: '#FFE8C5',
        },
        {
          name:'智能制造',
          color:'#374AEC',
          background:'#D1D6FC'
        },
        {
          name:'建筑工程',
          color:'#7909CE',
          background:'#E9D1FC'
        },
        {
          name:'证券金融',
          color:'#BEB101',
          background:'#FFFBC5',
        },
        {
          name:'通信',
          color:'#E93636',
          background:'#FED2D2'
        },
        {
          name:'能源',
          color:'#009F2A',
          background:'#CBF8D7',
        },
        {
          name:'轨道交通',
          color:'#00A2DF',
          background:'#D2F3FF',
        },
        {
          name:'石化',
          color:'#308805',
          background:'#DAF8CB',
        },
        {
          name:'有色金属',
          color:'#7909CE',
          background:'#E9D1FC',
        },
        {
          name:'金属冶炼',
          color:'#EFA83E',
          background:'#FFE8C5',
        },
      ],
    };
  },
  components: {
    Header,
    HussarForm,
    Footer,
    SideBar,
    ContactExperts,
    CustomCommentSwiper,
    CustomerLogoSlider
  },
  watch: {

  },
  methods: {
    // 预加载图片
    preloadImages(imageUrls) {
      imageUrls.forEach(url => {
        const img = new Image();
        img.src = url;
      });
    },
    getColor(name) {
      const self = this;
      let color = '';
      let background = '';
      for(let i = 0; i < self.colorList.length; i++){
        if (self.colorList[i].name === name) {
          color = self.colorList[i].color;
          background = self.colorList[i].background;
          break;
        }
      }
      return {
        color,
        background
      }
    },
    openForm() {
      const self = this;
      self.showForm = true;
    },
    closeForm() {
      const self = this;
      self.showForm = false;
    },

    // 页面滚动
    handleNavScroll() {
      const self = this;
      self.isPageScroll = false;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 80) {
        self.isPageScroll = true;
        self.headColor = 'dark';

      }else{
        self.headColor = 'light';
      }
    },
    getCustomCase(){
      const self = this;
      getCustomCase(self.articleData).then((res) =>{
        self.article = res.data.content;
        self.articleTotal = res.data.total;
        self.articlePage = Math.trunc(self.articleTotal/self.articleData.pageSize) + 1;
        // 预加载案例图片
        self.preloadImages(self.article.map(item => 'http://www.jxdinfo.com' + item.typeImg));
      }).catch((error) => {
        self.$message.error('未获取到文章!');
      });
    },
    forward(){
      const self = this;
      if(self.articleData.pageNo > 1){
        self.articleData.pageNo--;
        self.getCustomCase();
      }
    },
    backward(){
      const self = this;
      if(self.articleData.pageNo < self.articlePage){
        self.articleData.pageNo++;
        self.getCustomCase();
      }
    },
    getApplication(){
      getApplication(this.applicationData).then((res) =>{
        res.data.content.reverse();
        this.application = res.data.content;
        // 预加载应用行业图片
        this.preloadImages(this.application.map(item => 'http://www.jxdinfo.com' + item.typeImg));
      }).catch((error) => {
        self.$message.error('未获取到应用行业!');
      });
    },
    getCustomLogo(){
      const self = this;
      getCustomLogo(self.customLogoData).then((res) =>{
        res.data.content.reverse();
        self.customLogo = res.data.content;
        // 预加载客户logo
        self.preloadImages(self.customLogo.map(item => 'http://www.jxdinfo.com' + item.typeImg));
      }).catch((error) => {
        self.$message.error('未获取到客户商标!');
      });
    },
    // 返回顶部
    backTop() {
      $('html ,body').animate({scrollTop: 0}, 700);
    },
  },
  mounted() {
    const self = this;
    self.getCustomCase();
    self.getApplication();
    self.getCustomLogo();
    window.addEventListener('scroll', self.handleNavScroll);
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid &&       !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
    if (os.isAndroid || os.isPhone) {
      this.$router.replace({ path: '/CasePhonePage' });
    }
  },
  created() {},
}
</script>

<style scoped>
.home {color: #2E2E2E;background: rgba(249, 251, 254, 1)}
.home >>>.header-box{background: rgba(255, 255, 255, 0);}
.home >>>.header-fixed {background: rgba(255, 255, 255, 0.9);transition: all .45s ease;}
.home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
.home >>>.nav-light >.navigator .isActive{color: #fff}
.home >>>.nav-light >.navigator .isActive::after{background: #fff}
.banner-bg{background: #071132}
.banner-box{width:100%;height:630px;background: url("../assets/img/casePage/banner-bg.jpg"); background-position: 50%;background-repeat: no-repeat;}
.banner-text{width:1200px;color: #FFFFFF;text-align: center;padding-top:160px;padding-bottom: 100px;margin:  0 auto;}
.banner-title{font-size: 48px;font-weight: bold;}
.banner-desc{font-size: 24px;font-weight: 400;margin-top: 20px;}
/*评论*/
.customerComments{width:1200px;height: 215px;margin: 0 auto;position: relative;}
.customerComments img{vertical-align: middle;}
.customerCommentsStyle{background: linear-gradient(90deg, rgba(88,140,245,0.1) 0%, rgba(39,102,248,0.85) 100%);position: absolute;}
.developmentExperience{opacity: 0; position: absolute;left: 355px;color: #fff;font-size:14px;width: 280px;height: 35px;border-radius: 17px;line-height: 35px;}
.developmentExperience div{width:250px;margin:0 auto;display: flex;align-items: center;justify-content: center;}
.developmentExperience img{width:18px;height: 18px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.poc{opacity: 0;position:absolute;top: 8px;left:700px;width: 190px;height: 36px;color: #fff;font-size:16px;border-radius: 18px;line-height: 36px;}
.poc div{width:150px;margin: 0 auto;display: flex;align-items: center;justify-content: center;}
.poc img{width:20px;height: 20px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.technicalRoutes{opacity: 0;position:absolute;top: 44px;left:195px;width:175px;height:36px;color: #fff;font-size:16px;border-radius: 18px;line-height: 36px;}
.technicalRoutes div{width:140px;margin: 0 auto;display: flex;align-items: center;justify-content: center;}
.technicalRoutes img{width:21px;height: 21px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.safe{opacity: 0;position:absolute;top: 54px;left:450px;width:260px;height:40px;color: #fff;font-size:18px;border-radius: 20px;line-height: 40px;}
.safe div{width:230px;margin: 0 auto;display: flex;align-items: center;justify-content: center;}
.safe img{width:20px;height: 20px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.expansion{opacity: 0;position:absolute;top: 54px;left:785px;width:240px;height:36px;color: #fff;font-size:16px;border-radius: 18px;line-height: 36px;}
.expansion div{width:210px;margin: 0 auto;display: flex;align-items: center;justify-content: center;}
.expansion img{width:20px;height: 20px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.service{opacity: 0;position:absolute;top: 100px;left:110px;width:260px;height:40px;color: #fff;font-size:18px;border-radius: 20px;line-height: 40px;}
.service div{width: 230px;margin: 0 auto;display: flex;align-items: center;justify-content: center;}
.service img{width: 25px;height: 25px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.reversible{opacity: 0;position:absolute;top: 140px;left:390px;width:150px;height:30px;color: #fff;font-size:14px;border-radius: 15px;line-height: 30px;}
.reversible div{width: 130px;margin: 0 auto;display: flex;align-items: center;justify-content: center;}
.reversible img{width: 18px;height: 18px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.costSave{opacity: 0;position:absolute;top: 110px;left:610px;width:210px;height:40px;color: #fff;font-size:18px;border-radius: 20px;line-height: 40px;}
.costSave div{width: 180px;margin: 0 auto;display: flex;align-items: center;justify-content: center;}
.costSave img{width: 23px;height: 23px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.nationalInternet{opacity: 0;position:absolute;top: 130px;left:880px;width:210px;height:33px;color: #fff;font-size:14px;border-radius: 16px;line-height: 33px;}
.nationalInternet div{width: 180px;margin: 0 auto;display: flex;align-items: center;justify-content: center;}
.nationalInternet img{width: 17px;height: 17px;display: flex;align-items: center;justify-content: center;margin-right: 5px;}
.showOrHide1{animation-name: showOrHide1; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide1 {
  0%   {opacity: 0}
  10%  {opacity: 1}
  74%  {opacity: 1}
  100% {opacity: 0}
}
.showOrHide2{animation-name: showOrHide2; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide2 {
  0%   {opacity: 0}
  20%  {opacity: 1}
  76%  {opacity: 1}
  100% {opacity: 0}
}
.showOrHide3{animation-name: showOrHide3; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide3 {
  0%   {opacity: 0}
  30%  {opacity: 1}
  78%  {opacity: 1}
  100% {opacity: 0}
}
.showOrHide4{animation-name: showOrHide4; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide4 {
  0%   {opacity: 0}
  37%  {opacity: 1}
  80%  {opacity: 1}
  100% {opacity: 0}
}
.showOrHide5{animation-name: showOrHide5; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide5 {
  0%   {opacity: 0}
  45%  {opacity: 1}
  82%  {opacity: 1}
  100% {opacity: 0}
}
.showOrHide6{animation-name: showOrHide6; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide6 {
  0%   {opacity: 0}
  50%  {opacity: 1}
  84%  {opacity: 1}
  100% {opacity: 0}
}
.showOrHide7{animation-name: showOrHide7; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide7 {
  0%   {opacity: 0}
  55%  {opacity: 1}
  86%  {opacity: 1}
  100% {opacity: 0}
}
.showOrHide8{animation-name: showOrHide8; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide8 {
  0%   {opacity: 0}
  60%  {opacity: 1}
  88%  {opacity: 1}
  100% {opacity: 0}
}
.showOrHide9{animation-name: showOrHide9; animation-duration: 12s;animation-iteration-count: infinite;}
@keyframes showOrHide9 {
  0%   {opacity: 0}
  60%  {opacity: 1}
  90% {opacity: 1}
  100% {opacity: 0}
}
.developmentExperience:hover, .poc:hover, .technicalRoutes:hover, .safe:hover, .expansion:hover,
.service:hover, .reversible:hover, .costSave:hover, .nationalInternet:hover{
  transform: translate(5px,-5px);transition: all 500ms ease;border: 1px rgba(75, 206, 255, 1) solid;animation-duration: 0s;opacity: 1}
/*典型案例*/
.customCase{width: 100%;background: rgba(249, 251, 254, 1)}
.customTitle{text-align:center;height:50px;font-size: 34px;font-weight: bold;color: #2E2E2E;margin: 80px auto 50px;}
.article-box{width:1230px;margin: 0 auto;height:820px}
.customArticle{width:275px;height:365px;box-shadow: 0px 0px 10px 1px rgba(0,65,178,0.16);border-radius:5px;float: left;margin: 0 15px 50px;}
.customArticle:hover{transform: translate(0,-10px);transition: all 500ms ease;}
.customImg{width:275px;height: 190px;box-shadow: none;}
.customImg img{width: 100%;height: 100%;border-radius: 5px 5px 0 0 ;}
.customArticleTitle{margin-left: 25px;margin-top: 25px;font-size: 16px;font-weight: bold;color: #2E2E2E;}
.customArticleTitle span{margin-left:8px;font-size: 12px;border-radius: 5px;font-weight: normal;display: inline-block;padding: 0 10px;height: 22px;text-align: center;line-height: 22px;}
.customArticleDesc{font-size:14px;margin-left: 25px;margin-top: 17px;width:230px;height:65px;color: #2E2E2E;line-height: 23px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;}
.overIndex{width: 200px;height: 40px;margin: 40px auto 55px;color: #707070;font-size: 16px;line-height: 30px;display: flex;align-items: center;justify-content: center;}
.overIndex span{margin:0 15px;}
/*应用行业*/
.application{background-color: rgba(249, 251, 254, 1)}
.applicationBox{width: 1050px;margin: 0 auto;}
.applicationTitle{height:40px;font-size: 28px;font-weight: bold;color: #2E2E2E;margin: 45px auto 40px;text-align: center;}
.applicationCustom{margin:0 5px 50px;position:relative;width: 165px;height: 70px;background: linear-gradient(0deg, rgba(249, 251, 254, 1), rgba(232, 242, 255, 1)); float: left;}
.applicationSeat{display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;}
.applicationCustom-desc{margin-left:10px;font-size: 18px;}
/*更多客户*/
.custom-box{background: rgba(249, 251, 254, 1);margin-top: 20px;}
.custom-box .customTitle{margin:0 auto;padding-top: 50px}
.customLogo-box{margin: 0 auto 120px; width:1230px}
#moreCustom{margin-top: 85px; margin-bottom: 65px}
.customLogo{background: #fff;width:145px;height:65px;box-shadow: 0 0 20px 1px rgba(0,65,178,0.07);border-radius: 8px 8px 8px 8px;margin:15px;
  display: flex;align-items: center;justify-content: center;line-height:65px;float:left;}
/* 返回顶部 */
.back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
.home>>> .contact-box{background: url('../assets/img/casePage/contact-bg.jpg') no-repeat 50%;}
</style>



// WEBPACK FOOTER //
// src/components/CasePage.vue